import { ArrowTopRightOnSquareIcon } from '@heroicons/react/24/outline';
import {
  CloudConsoleIcon,
  type CloudConsoleIconProps,
} from './cloud-console-icon';
import { isCloudConsoleUrl } from './is-cloud-console-url';

export type LinkOutIconProps = CloudConsoleIconProps & {
  href: string | null | undefined;
};

// The cloud icon for a link to a cloud provider's console, the usual
// open-in-new-window arrow for anything else
export function LinkOutIcon({ href, ...props }: LinkOutIconProps) {
  if (isCloudConsoleUrl(href)) {
    return <CloudConsoleIcon data-icon="cloud-console" {...props} />;
  }
  return <ArrowTopRightOnSquareIcon data-icon="link-out" {...props} />;
}
